import { Container, Row } from "reactstrap";
import { BonusUi, Carousel } from "../../../constants";
import AutoPlayVariant from "./AutoPlayVariant";
import MouseWheelVariant from "./MouseWheelVariant";
import SlidesOnly from "./SlidesOnly";
import WithControls from "./WithControls";
import WithIndicators from "./WithIndicators";
import WithCaptions from "./WithCaptions";
import CrossFade from "./CrossFade";
import IndividualInterval from "./IndividualInterval";
import DisableTouchSwiping from "./DisableTouchSwiping";
import DarkVariant from "./DarkVariant";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const CarouselContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Carousel} parent={BonusUi} />
      <Container fluid>
        <Row>
          <SlidesOnly />
          <WithControls />
          <AutoPlayVariant />
          <MouseWheelVariant />
          <WithIndicators />
          <WithCaptions />
          <CrossFade />
          <IndividualInterval />
          <DisableTouchSwiping />
          <DarkVariant />
        </Row>
      </Container>
    </>
  );
};

export default CarouselContainer;
